import { ScopeReportLineItem, ScopeReportLineItemWithChangeData } from '@kaiizen/kai-pro-api';
import { DEFAULT_TEMPLATE_SORT_CONFIG, sortLineItemsByMultipleFields } from '@kaiizen/kai-reports';
import { useMemo } from 'react';
import {
  filterChangeOrderLineItems,
  filterPunchlistLineItems,
} from '../Filters';
import { ReportType } from '../ScopeReportTypes';

export type ReportData = {
  reportType: ReportType;
  scopeLineItems: ScopeReportLineItem[];
  diffScopeLineItems: ScopeReportLineItemWithChangeData[];
};

export type ReportDataProps = Partial<ReportData> & { reportType: ReportType };

const getFilteredScopeLineItems = ({ scopeLineItems, diffScopeLineItems, reportType }: ReportDataProps): ScopeReportLineItem[] => {
  if (reportType === 'changeOrder') return diffScopeLineItems ? filterChangeOrderLineItems(diffScopeLineItems) : [];
  if (reportType === 'punchlist') return scopeLineItems ? filterPunchlistLineItems(scopeLineItems) : [];
  if (reportType === 'fullScope' || reportType === 'closeout') return scopeLineItems ?? [];
  return [];
};

export const getReportData = ({ scopeLineItems, diffScopeLineItems, reportType }: ReportDataProps): ReportData => ({
  reportType,
  scopeLineItems: sortLineItemsByMultipleFields(getFilteredScopeLineItems({ scopeLineItems, diffScopeLineItems, reportType }), DEFAULT_TEMPLATE_SORT_CONFIG),
  diffScopeLineItems: sortLineItemsByMultipleFields(diffScopeLineItems ? filterChangeOrderLineItems(diffScopeLineItems) : [], DEFAULT_TEMPLATE_SORT_CONFIG),
});

export const useReportDataPipeline = ({ scopeLineItems, diffScopeLineItems, reportType }: ReportDataProps): ReportData =>
  useMemo(() => getReportData({ reportType, scopeLineItems, diffScopeLineItems }), [scopeLineItems, diffScopeLineItems, reportType]);
